module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/shoals.8b99cb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/shoals.jpg
// module id = P4cM
// module chunks = 0